<div class="banner-content">
  <div class="pl-6 pl-lg-12 pb-4" *ngIf="description">
    <py-badge [large]="true" [tag]="true" [showCircle]="false" [type]="campaignBadgeType">
      {{ description | ellipsis : { showLastString: false } }}
    </py-badge>
  </div>

  <div class="title pl-6 pl-lg-12 pr-4 pr-lg-0 pb-4">
    {{ activeBannerEntry?.text | ellipsis : { showLastString: false } }}
  </div>

  <div class="offer pl-6 pl-lg-12 pb-4">
    <cx-generic-link [class]="'btn btn-primary'" [url]="activeBannerEntry?.link">
      {{ 'catalog.seeOffer_action' | cxTranslate }}
    </cx-generic-link>
  </div>
</div>

<div class="d-none d-sm-flex action">
  <button (click)="toggleState()">
    <i nz-icon [nzType]="isBannerEntryStopped ? 'right' : 'pause'" nzTheme="outline"></i>
  </button>
</div>

<div class="d-flex justify-content-center">
  <img class="background-image" [pyMedia]="activeBannerEntry?.image" [alt]="activeBannerEntry?.text" />
</div>
